import Api from "../config/api";

export const aiGerarResumo = async (sujeitoAtencaoId) => {
    const response = await Api.post("", {
        query: `
             {
                aiGerarResumo(sujeitoAtencaoId: "${sujeitoAtencaoId}")
            }
        `,
    });

    if (response.data.errors) {
        throw new Error('Erro ao gerar resumo');
    }

    return response;
};

export const aiEstruturarProntuarioRetorno = async (texto) => {
    const response = await Api.post("", {
        query: `
            query($texto: String) {
                aiEstruturarProntuarioRetorno(texto: $texto)
            }
        `,
        variables: { texto }
    });

    if (response.data.errors) {
        throw new Error('Erro ao estruturar prontuário');
    }

    return response.data.data.aiEstruturarProntuarioRetorno;
};

export const findResumoAvaliacaoById = async (id) => {
    const response = await Api.post("", {
        query: `
            query($id: UUID) {
                findResumoAvaliacaoById(id: $id) {
                    id
                    motivo
                    sujeitoAtencao {
                        id
                    }
                    profissionalSaude{
                        id
                    }
                    tipo
                    gostou
                }
            }
        `,
        variables: { id }
    });

    if (response.data.errors) {
        throw new Error('Erro ao buscar resumo avaliação');
    }

    return response;
};

export const saveResumoAvaliacao = async (resumoAvaliacao) => {
    const response = await Api.post("", {
        query: `
            mutation($resumoAvaliacao: ResumoAvaliacaoInput) {
                saveResumoAvaliacao(resumoAvaliacao: $resumoAvaliacao) {
                    id
                    motivo
                    sujeitoAtencao {
                        id
                    }
                    profissionalSaude{
                        id
                    }
                    tipo
                    gostou
                }
            }
        `,
        variables: { resumoAvaliacao }
    });

    if (response.data.errors) {
        throw new Error('Erro ao salvar resumo avaliação');
    }

    return response;
};

export const findAllResumoAvaliacao = async (profissionalSaudeId, sujeitoAtencaoId, tipo) => {
    const response = await Api.post("", {
        query: `
            query($profissionalSaudeId: String, $sujeitoAtencaoId: UUID, $tipo: TipoResumoAvaliacao) {
                findAllResumoAvaliacao(profissionalSaudeId: $profissionalSaudeId, sujeitoAtencaoId: $sujeitoAtencaoId, tipo: $tipo) {
                    id
                    motivo
                    sujeitoAtencao {
                        id
                    }
                    profissionalSaude{
                        id
                    }
                    tipo
                    gostou
                }
            }
        `,
        variables: { profissionalSaudeId, sujeitoAtencaoId, tipo }
    });

    if (response.data.errors) {
        throw new Error('Erro ao buscar resumo avaliação');
    }

    return response
};

export const aiEstruturarProntuarioConsulta = async (texto) => {
    const response = await Api.post("", {
        query: `
            query($texto: String) {
                aiEstruturarProntuarioConsulta(texto: $texto)
            }
        `,
        variables: { texto }
    });

    if (response.data.errors) {
        throw new Error('Erro ao estruturar prontuário');
    }

    return response.data.data.aiEstruturarProntuarioConsulta;
};

export const enviarArquivosAudioParaResumo = async (agendamentoId) => {
    const response = await Api.post("", {
        query: `
            mutation($agendamentoId: Long) {
                enviarArquivosAudioParaResumo(agendamentoId: $agendamentoId)
            }
        `,
        variables: { agendamentoId }
    });

    if (response.data.errors) {
        throw new Error('Erro ao enviar arquivos de áudio para resumo');
    }

    return response;
};
export const uploadArquivoAudio = async (objetoAmazonS3DTO, profissionalSaude, sujeitoAtencao, agendamento) => {
    const response = await Api.post("", {
        query: `
            mutation($objetoAmazonS3DTO: ObjetoAmazonS3DTOInput, $profissionalSaude: ProfissionalSaudeInput, $sujeitoAtencao: SujeitoAtencaoInput, $agendamento: AgendamentoInput) {
                uploadArquivoAudio(objetoAmazonS3DTO: $objetoAmazonS3DTO, profissionalSaude: $profissionalSaude, sujeitoAtencao: $sujeitoAtencao, agendamento: $agendamento) {
                    id
                }
            }
        `,
        variables: { objetoAmazonS3DTO, profissionalSaude, sujeitoAtencao, agendamento }
    });

    if (response.data.errors) {
        throw new Error('Erro ao fazer upload do arquivo');
    }

    return response;
};

export const downloadAudio = async (key) => {
    const response = await Api.post("", {
        query: `
            query($key: String) {
                downloadAudio(key: $key)
            }
        `,
        variables: { key }
    });

    if (response.data.errors) {
        throw new Error('Erro ao fazer download do áudio');
    }

    return response;
};

export const registraClickFuncaoChave = async (funcaoChave) => {
    try {
        await Api.post("", {
            query: `
                mutation ($funcaoChave: FuncaoChave) {
                    registraClickFuncaoChave(funcaoChave: $funcaoChave) {
                        id
                    }
                }
            `,
            variables: { funcaoChave }
        });
    
    } catch (error) {
        console.error(error);
    }
};